var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiOutlineUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 4.66667C10.6666 6.13943 9.47274 7.33333 7.99998 7.33333C6.52722 7.33333 5.33331 6.13943 5.33331 4.66667C5.33331 3.19391 6.52722 2 7.99998 2C9.47274 2 10.6666 3.19391 10.6666 4.66667Z",
    stroke: "#5A6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 9.33333C5.42265 9.33333 3.33331 11.4227 3.33331 14H12.6666C12.6666 11.4227 10.5773 9.33333 7.99998 9.33333Z",
    stroke: "#5A6273",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiOutlineUser);
export default __webpack_public_path__ + "static/media/hi-outline-user.a1490961149ac8c88c0c2d4d9281db00.svg";
export { ForwardRef as ReactComponent };